import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { EmailMessage, Order } from 'app/core/model/entity-model';
import { EmailDialogComponent } from 'app/shared/email-dialog/email-dialog.component';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-email-search',
    templateUrl: './email-search.component.html',
    styleUrls: ['./email-search.component.scss'],
    standalone: false
})
export class EmailSearchComponent implements OnInit {
    emails: any;
    filter: any;
    showAll: boolean = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, private router: Router, public auth: AuthService, private modalService: BsModalService) {}

    async ngOnInit() {
        await this.uow.getUsers();
        await this.getData();
    }

    async getData() {
        this.emails = await this.uow.getEmails(['invoice', 'salesOrder', 'purchaseOrder'], this.showAll ? null : 500);
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(orderId: number) {
        this.router.navigate(['/sales-orders/' + (!!orderId ? orderId : 'new')]);
    }

    async openEmail(email: EmailMessage) {
        const modalRef = this.modalService.show(EmailDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                email: email,
                readOnly: true,
                mode: email.type
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            modalRef.hide();
        });
    }

    async rowDoubleClick(e) {
        if (!e.data) return;
        await this.openEmail(e.data);
    }

    async toggleShowAll() {
        this.showAll = !this.showAll;
        await this.getData();
    }
}
